import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import styles from "../../cards.module.scss"
function ExternalResourceItem({ resource, handleClickResource, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}

      onClick={handleClickResource || undefined}>
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{resource.title}</p>
          <span className={styles.subtitle}>{resource.src_url}</span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('solarys.themeList', resource.theme).label,
              bgColor: 'bg-orange-700'
            }}
          />
          {resource.public_list.map((o, key) => (
            <Tag
              key={key}
              tag={{
                label: o.label,
                bgColor: 'bg-yellow-500'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExternalResourceItem;
